import { MouseEvent, useMemo, useState } from 'react'

import { IconEdit, IconFolder, IconTrash } from '@tabler/icons-react'
import styled from 'styled-components'

import { UpdateDocumentFolder } from './UpdateDocumentFolder'

import { FolderData, useDocumentFolders } from '@/hooks/useDocumentFolders'

import { buildPassTheme } from 'src/styles/theme'

const COLOUR_SCHEME = {
  normal: {
    colour: buildPassTheme.colour.primary._700,
    fill: buildPassTheme.colour.primary._300,
  },
  // please think hard before removing these, it's a very important feature for reasons...
  tessa: {
    colour: '#e0218a',
    fill: '#f29ad8',
  },
  wardle: {
    colour: '#ff0000',
    fill: '#ff7c7c',
  },
}

const schemes = Object.keys(COLOUR_SCHEME)

const EditWrapper = styled.span`
  display: none;
  align-items: center;
  gap: 0.5rem;
`

const Wrapper = styled.div`
  ${({ theme }) => theme.font.body03}
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover,
  &:focus {
    text-decoration: underline;

    ${EditWrapper} {
      display: flex;
    }
  }
`

type Props = {
  folder: FolderData
  onUpdate?: () => void
}

export const DocumentFolderRow: React.FC<Props> = ({ folder, onUpdate }) => {
  const { setFolderId } = useDocumentFolders(false)

  const [updateModalOpen, toggleModalOpen] = useState(false)

  const scheme = useMemo(() => {
    const chunks = folder.folderName?.toLowerCase().split(/[^A-Za-z]/) // split by non-alphabetical characters

    for (const chunk of chunks) {
      if (schemes?.includes(chunk)) {
        return COLOUR_SCHEME[chunk]
      }
    }

    return COLOUR_SCHEME.normal
  }, [folder.folderName])

  const onEdit = (e: MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation()
    toggleModalOpen(true)
  }

  return (
    <>
      <Wrapper
        onClick={() => setFolderId(folder.folderId)}
        style={{ color: scheme.colour }}
      >
        <IconFolder
          size={24}
          stroke={1.5}
          color={scheme.colour}
          fill={scheme.fill}
        />
        {folder.folderName}

        <EditWrapper onClick={onEdit}>
          <IconEdit size={16} />
          <IconTrash size={16} />
        </EditWrapper>
      </Wrapper>

      <UpdateDocumentFolder
        folder={folder}
        open={updateModalOpen}
        onClose={() => toggleModalOpen(false)}
        onUpdate={onUpdate}
      />
    </>
  )
}
